export default "__VITE_ASSET__D62sO_cq__"